import angular from 'angular';

let attendanceDetailController = function ($filter, $mdDialog, $scope, $state, Attendance, Toast) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.attendance;

  angular.extend($ctrl, {
    showCreateDialog,
    pre_attendance_medical_requests
  });

  $scope.activeStatus = function (resource) {
    Attendance
      .save(resource)
      .then(response => {
        $ctrl.attendance = response;
        let messageSuccess = $filter('translate')('attendance-list-active-success')
        Toast.success(messageSuccess);
      })
      .catch(err => {
        console.log('err:' ,  err);
        let messageError = $filter('translate')('attendance-list-active-error')
        Toast.error(messageError);
      });
  };

  activate();

  function pre_attendance_medical_requests() {
    if ($ctrl.attendance) {
      const oldUri = [{
        image_uri: $ctrl.attendance.medical_request_uri
      }];
      let dataArray = $ctrl.attendance.pre_attendance_medical_requests;
      if ($ctrl.attendance.medical_request_uri) dataArray = dataArray.concat(oldUri);
      return dataArray || [];
    }
    return [];
  }

  function activate() {
    loadResource($ctrl.id);
  }

  // Local functions
  function loadResource(id) {
    if (id) {
      $ctrl.uiState = 'LOADING';

      Attendance.show(id)
        .then(response => {
          $ctrl.attendance = response;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
      $scope.$apply();
    }
  }

  function showCreateDialog(event, selectedAttendance, uri) {
    $ctrl.selectedAttendance = selectedAttendance;

    let title = '\'attendance-detail-medical-request-title\'';
    // let uri = $ctrl.selectedAttendance.medical_request_uri;

    let dialog = {
      controller: DialogController,
      targetEvent: event,
      template:
      '<md-dialog aria-label="List dialog">' +
      '  <md-dialog-content class="layout-padding">'+
      '  <div class="md-dialog-content" >'+
      '    <h2>{{ ' + title + ' | translate }}</h2><br>'+
      '    <md-input-container class="md-block" flex>'+
      '      <img class="sb-medical-request-image-dialog" src="' + uri  + '" >'+
      '    </md-input-container>' +
      '    </div>' +
      '    </md-dialog-content>' +
      '  <md-dialog-actions>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose:true,
      fullscreen: false
    };

    dialog.template += '' +
    '    <md-button ng-click="cancel()">' +
    '      {{ \'common-ok\' | translate }}' +
    '    </md-button>' +
    '  </md-dialog-actions>' +
    '</md-dialog>';

    $mdDialog.show(dialog)
      .then((differential) => {
        if (selectedAttendance) {
          differential = angular.extend(selectedAttendance, differential);
        }
      }, () => {});
  }

  function DialogController($scope, $mdDialog) {
    "ngInject";

    $scope.differential = angular.copy($ctrl.selectedAttendance) || {};

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };
  }
}

attendanceDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Attendance', 'Toast'];

export default attendanceDetailController;



// WEBPACK FOOTER //
// ./client/app/components/attendance/attendance-detail.controller.js